import useResponsiveRedux from '../Hooks/useResponsiveRedux';
import ListWrestlers from '../../pages/ListWrestlers';
import ListWrestlersMobile from '../../pages/Mobile/ListWrestlersMobile';

const ListWrestlersResponsive = () => {
    const { isMobile } = useResponsiveRedux();

    return isMobile ? <ListWrestlersMobile /> : <ListWrestlers />;
};

export default ListWrestlersResponsive;